import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import '../styles/MainHeader.css';
import SideNavigation from "./SideNavigation";
import PanelMenu from "./SidebarOryza";

const MainHeader = () => {
    const [scrolled, setScrolled] = useState(false);
    const [isNavOpen, setIsNavOpen] = useState(false);
    const [showPanel, setShowPanel] = useState(false);
    
    useEffect(() => {
        const handleScroll = () => {
           setScrolled(window.scrollY > 50);
       };

        const handleResize = () => {
           // Auto-open only when width is exactly 1280
           setIsNavOpen(window.innerWidth === 1280);
       };

        // Initial check
        handleScroll();
        handleResize();

        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', handleResize);

        return () => {
           window.removeEventListener('scroll', handleScroll);
           window.removeEventListener('resize', handleResize);
       };
    }, []);

    const toggleNav = () => {
        setIsNavOpen(!isNavOpen);
    };

    const togglePanel = () => {
        setShowPanel(!showPanel);
    };

    return (
        <>
            <header className={`transparent-header ${scrolled ? 'scrolled' : ''}`}>
                <div className="container-size">
                    <div className="row align-items-center" style={{ padding: "10px 0" }}>
                        <div className="col-lg-1 col-md-1 col-sm-2 mobi1">
                            <Link to="/BananaBunksKandy" className="logo_normal">
                                <img
                                    src="/bbkandy/images/logo/logo.png"
                                    alt="Banana Bunks"
                                    style={{
                                        height: "50px",
                                        width: "auto",
                                        filter: scrolled ? 'none' : 'brightness(0) invert(1)'
                                    }}
                                />
                            </Link>
                        </div>
                        <div className="col-lg-2 col-md-10 col-sm-8 mobi2">
                            <a href="#0" className="menu_open" onClick={togglePanel}>
                                <img src="/pettipetti/img/logo/home.png" alt="Menu" width="150px" style={{ filter: scrolled ? 'none' : 'brightness(0) invert(1)' }} />
                            </a>
                        </div>
                        <div className="col-lg-1 col-md-1 col-sm-2 mobi3">
                            <div className="hamburger2 open_close_nav_panel mobileonly" onClick={toggleNav} style={{ cursor: "pointer" }}>
                                <img src="/bbkandy/images/logo/hamburger.png" alt="Hamburger" style={{
                                    width: "35px",
                                    filter: scrolled ? 'none' : 'brightness(0) invert(1)'
                                }} />
                            </div>
                        </div>

                        <div className="col-lg-8 col-md-8 col-sm-6 main-menu-nav">
                            <div className="main-menu">
                                <nav id="mainNav">
                                    <ul>
                                        <li><a href="/BananaBunksKandy" style={{ color: '#fff' , lineHeight : "22px"}}>HOME</a></li>
                                        <li><a href="/BananaBunksKandy/room" style={{ color: '#fff' ,lineHeight : "22px"}}>ROOMS & BUNKS</a></li>
                                        <li><a href="/BananaBunksKandy/dining" style={{ color: '#fff',lineHeight : "22px" }}>EAT & DRINK</a></li>
                                        <li><a href="/BananaBunksKandy/gallery" style={{ color: '#fff',lineHeight : "22px" }}>GALLERY</a></li>
                                        <li><a href="/BananaBunksKandy/offers" style={{ color: '#fff' ,lineHeight : "22px"}}>OFFERS</a></li>
                                        <li><a href="/BananaBunksKandy/aboutus" style={{ color: '#fff',lineHeight : "22px" }}>ABOUT US</a></li>
                                        <li><a href="/BananaBunksKandy/contactus" style={{ color: '#fff',lineHeight : "22px" }}>CONTACT US</a></li>
                                        <li><a href="https://app.channelmanager.com.au/booknow/Chain/kent-chain-135" target="_blank" rel="noopener noreferrer" className="btn_1_outline" style={{ color: '#fff',lineHeight : "22px" }}>BOOK YOUR STAY</a></li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            <SideNavigation isOpen={isNavOpen} onClose={toggleNav} />
            <div className={`panel-overlay ${showPanel ? 'visible' : ''}`} onClick={togglePanel}>
  <div className="panel-container" onClick={(e) => e.stopPropagation()}>
    <PanelMenu show={showPanel} onClose={togglePanel} />
  </div>
</div>

        </>
    );
};

export default MainHeader;